
export function performanceLog( message: string, startTime: number, lineLength: number = 100 ) {
    console.log( `${message} - ${Math.round( 1000 * ( performance.now() - startTime ) ) / 1000} ms`.asLogLine( lineLength ) );
}